import { OrderDirection } from 'store/spot/types'
import { Price, Quantity, SymbolId, SymbolName } from 'types'
import { ApiV1Response, http } from './http'

export interface OrderbookResponse {
  symbolId: SymbolId
  symbol: SymbolName
  price: Price
  sellOrders: [Price, Quantity][]
  buyOrders: [Price, Quantity][]
  sequenceId: number
  direction: OrderDirection
}
export async function getOrderbook<T extends ApiV1Response<OrderbookResponse>>(
  symbolName: SymbolName,
): Promise<T> {
  const r = await http.get(`/market/orderBook/${symbolName}`)
  return r.data
}


export interface RecentData {
  [x: SymbolName]: string[]
}
export async function getRecentHistory<T extends ApiV1Response<RecentData>>(symbolName: SymbolName): Promise<T>{
  const r = await http.get(`/market/tick/history/${symbolName}`)
  return r.data
}